import { Component, input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { SentEmailFilter } from '../../../../core/filters/sent-email.filter';
import { EmailDeliveryStatus, EmailType } from '../../../../core/enums/data.enums';
import { ListConstants } from '../../../../core/constants/lists.constants';
import { ParentFocusDirective } from '../../../../core/directives/parent-focus.directive';
import { MultiSelectComponent } from '../../../../parts/multi-select/multi-select.component';
import { BaseSearchFilterComponent } from '../../../../core/base-classes/base-search-filter.component';
import { EnumUtilities } from '../../../../core/utilities/enum.utilities';
import { DatePlaceholderDirective } from '../../../../core/directives/date-placeholder.directive';

@Component({
  selector: 'ms-sent-email-search-filter',
  imports: [CommonModule, FormsModule, FaDuotoneIconComponent, ParentFocusDirective, MultiSelectComponent, DatePlaceholderDirective],
  templateUrl: './sent-email-search-filter.component.html',
  styleUrl: './sent-email-search-filter.component.scss'
})
export class SentEmailSearchFilterComponent extends BaseSearchFilterComponent<SentEmailFilter> implements OnInit {
  public filter = input.required<SentEmailFilter>();

  public selectStatusOptions: EmailDeliveryStatus[] = Object.values(EmailDeliveryStatus);
  // Sorted by the display label the user actually sees (via EnumUtilities.convertToLabel + LABEL_OVERRIDES),
  // not the raw PascalCase enum value — otherwise "BasicEmailBlast" ("Email Blast") sorts under B, not E.
  public selectEmailTypeOptions: EmailType[] = Object.values(EmailType)
    .sort((a, b) => EnumUtilities.convertToLabel(a).localeCompare(EnumUtilities.convertToLabel(b)));

  public selectedStatuses: EmailDeliveryStatus[] = [];
  public selectedEmailTypes: EmailType[] = [];

  public ngOnInit(): void {
    this.selectedStatuses = [...(this.filter().statuses || [])];
    this.selectedEmailTypes = [...(this.filter().emailTypes || [])];
    this.setFilterCount();
  }

  public override get activeFilter(): SentEmailFilter {
    return this.filter();
  }

  protected override getDefaultFilter(): SentEmailFilter {
    return ListConstants.SENT_EMAILS_FILTER_DEFAULT();
  }

  protected override get preservedFilterKeys(): (keyof SentEmailFilter)[] {
    return ['organizationIds', 'timeZoneId', 'searchTerm'];
  }

  protected override get dropdownSelector(): string {
    return '#sent-email-search-filter-dropdown';
  }

  protected override syncStateFromFilter(): void {
    this.selectedStatuses = [...(this.filter().statuses || [])];
    this.selectedEmailTypes = [...(this.filter().emailTypes || [])];
  }

  public override setFilterCount(): void {
    const filter = this.filter();
    this.filterCount =
      (filter.statuses?.length || 0) +
      (filter.emailTypes?.length || 0) +
      (filter.minimumSentDate ? 1 : 0) +
      (filter.maximumSentDate ? 1 : 0);
  }

  public onStatusChange(event: EmailDeliveryStatus[]): void {
    this.filter().statuses = event;
  }

  public onEmailTypeChange(event: EmailType[]): void {
    this.filter().emailTypes = event;
  }
}
